// libraries
import React, { useContext } from "react";

// styles
import "./App.scss";

// context
// import UserContext from "src/context/User";
import { AdminAuthConsumer } from "src/context/AdminAuthContext";
import { UserAuthContext } from "./context/UserAuthContext";

// components
import { Route, Switch, Redirect } from "react-router-dom";

// pages
import Register from "./pages/Register";
import Details from "./pages/Events/Details";
import CreateEvent from "./pages/CreateEvent";
import Error from "./pages/Error";
import Profile from "./pages/Profile";
import ResetPassword from "./pages/ResetPassword";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import MyEvents from "./pages/MyEvents";
import Dashboard from "./pages/Dashboard/Dashboard";
import AdminLogin from "./pages/AdminLogin";
import Search from "./pages/Search";
import Test from "src/pages/Test";

import Login from "./pages/Login";
import NewRegister from "./pages/NewRegister";
import OTP from "./pages/OTP";

// bottom navigation pages
import Map from "./pages/Map";
import Home from "./pages/Home";

// dashboard components
import DashboardHome from "src/components/Dashboard/Home/Home";
import Analytics from "src/components/Dashboard/Analytics/Analytics";

// main layout
import { BottomNavigationLayout } from "src/layouts";

// utils
import ScrollToTop from "./custom_hooks/ScrollToTop";

import "./App.scss";

const App = () => {
  const { isLoading, user } = useContext(UserAuthContext);

  return (
    <div>
      <ScrollToTop />
      <Switch>
        {/* new screens */}
        <Route exact path="/new-login" component={Login} />
        <Route exact path="/register" component={NewRegister} />
        <Route exact path="/otp" component={OTP} />

        <Route exact path="/login" render={Register} />
        <Route exact path="/:slug/:eventId/:timeId" render={Details} />
        <Route exact path="/blogs" render={Blogs} />
        <Route exact path="/blogs/:slug" render={BlogDetail} />
        <Route exact path="/resetpassword/:code" render={ResetPassword} />
        <Route path="/404" component={Error} />

        {/* profile */}
        <Route exact path="/profile">
          {!isLoading && !user ? <Redirect to="/" /> : <Profile />}
        </Route>

        {/* my events route */}
        <Route exact path="/myevents">
          {!isLoading && !user ? <Redirect to="/login" /> : <MyEvents />}
        </Route>

        {/* create event route */}
        <Route exact path="/create-event">
          {!isLoading && (!user ? <Redirect to="/login" /> : <CreateEvent />)}
        </Route>

        {/* dashboard routes */}
        <Route exact path="/admin-login" component={AdminLogin} />
        <Route
          path="/dashboard"
          render={({ match: { url } }) => {
            return (
              <AdminAuthConsumer>
                {(auth) =>
                  !auth.isInitialized ? (
                    <div>Loader..</div>
                  ) : (
                    <Dashboard>
                      <Route exact path={`${url}/`} component={DashboardHome} />
                      <Route
                        exact
                        path={`${url}/analytics`}
                        component={Analytics}
                      />
                    </Dashboard>
                  )
                }
              </AdminAuthConsumer>
            );
          }}
        />

        {/* main layout with bottom bar routes */}
        <Route
          render={() => {
            return (
              <BottomNavigationLayout>
                <Switch>
                  <Route exact path="/" component={Home} />
                  <Route exact path="/map" component={Map} />
                  <Route exact path="/search" component={Search} />
                  <Route exact path="/test" component={Test} />
                  <Route path="*">
                    <Redirect to="404" />
                  </Route>
                </Switch>
              </BottomNavigationLayout>
            );
          }}
        />
      </Switch>
    </div>
  );
};

export default App;
